import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import {
  IMdaeDataGridColumnProps,
  IMdaeDataGridProps,
} from "../../../../common_components/common_widgets/data-grid";
import dxDataGrid from "devextreme/ui/data_grid";
import { Button, DataGrid } from "devextreme-react";
import { Column, Editing, Item, Selection, Toolbar } from "devextreme-react/data-grid";
import MdaeAddButton from "../../../../common_components/common_widgets/add-button";
import { useDispatch, useSelector } from "react-redux";
import MdaeAutoComplete from "../../../../common_components/common_widgets/autocomplete";
import { actions } from "async-ops";
import { GET_OUTCOMES_LIST } from "../../../external-audit-setup/outcomes/services/get-outcomes-list";
import MdaeButton from "../../../../common_components/common_widgets/button";
import {
  defaultBulkUpdateData,
  defaultTargetChargesGridSelection,
  OutcomeTypes,
  SET_BULK_UPDATE_DATA,
  SET_CURRENT_IMPORT_ROUND_DATA,
  SET_FROM_IMPORT_TYPE,
  SET_TARGET_CHARGES_GRID_CHECKBOXES,
  setLineLevelChargesDataGridInstance,
  TOGGLE_BULK_EDIT_TARGET_CHARGES_POPUP,
  TOGGLE_IMPORT_POPUP,
  UPDATE_CHARGES_ROUND_DATA,
} from "./reducers/case-data-reducer";
import {
  HIDE_LOADER,
  SHOW_LOADER
} from "../../../../common_components/mdae-common-reducer";
import MdaePopup, {
  MdaePopupContent,
  MdaePopupFooter,
  MdaePopupFooterEndButtons,
  MdaePopupFooterStartButtons,
  MdaePopupTitle,
} from "../../../../common_components/common_widgets/popup";
import MdaeSelectBox from "../../../../common_components/common_widgets/select-box";
import CustomStore from "devextreme/data/custom_store";
import { callOperation } from "async-ops";
import { GET_EA_TARGET_VALUE_SOURCES } from "../../services/get-ea-target-value-sources";
import MdaeTextBox from "../../../../common_components/common_widgets/text-box";
import UploadTargetDataPopup, { toggleUploadTargetDataPopup } from "./upload-line-level-charges";
import { first } from "lodash";
import {
  toggleBillHistoryPopupVisible
} from "../../case-list/bill-history";
import ClaimDetail, {
  toggleClaimDetailPopupVisible,
} from "../../case-list/claim-detail/component";
import { GET_TARGET_RATIONALE_LOOKUP_DATA } from "../../services/get-target-rationale-lookup-data";
import { toggleRemitDetailPopupVisible } from "../../case-list/remit-detail/component";
import { GET_CASE_BILLING_HISTORY } from "../../case-list/services/get-case-billing-history";

export const roundTrackingGridFields = Object.freeze({
  totalRetainedAmnt: "totalRetainedAmnt",
  totalRefundAmnt: "totalRefundAmnt",
  reviewRemainingAmnt: "reviewRemainingAmnt",
  totalRevenueLoss: "totalRevenueLoss",
  atRiskAmnt: "atRiskAmnt",
  roundTargetType: "roundTargetType",
  roundTargetValue: "roundTargetValue",
  denialReason: "denialReason",
  roundOutcomeId: "roundOutcomeId",
  outcomeType: "outcomeType",
  targetRationale: "targetRationale",
});

const atRisk = "atRisk";
const importType ={
  CLAIM: "CLAIM",
  REMIT: "REMIT"
}

const toggleBulkEditTargetChargesPopup = (isVisible, dispatch) => {
  dispatch({
    type: TOGGLE_BULK_EDIT_TARGET_CHARGES_POPUP,
    data: {
      isBulkEditTargetChargesPopupVisible: isVisible,
    },
  });
};

const toggleImportPopup = (isVisible, dispatch) => {
  dispatch({
    type: TOGGLE_IMPORT_POPUP,
    data: {
      isImportPopupVisible: isVisible,
    },
  });
};

function useTargetTypeDatasource({
  targetType,
  caseData,
  completeCaseDetail,
  auditPropertiesData,
  targetTypeLookup,
  dispatch,
}) {
  return useMemo(
    () => ({
      store: new CustomStore({
        key: "code",
        load: (loadOptions) => {
          return new Promise((resolve) => {
            const codeType = targetTypeLookup.find(
              (x) => x.value === targetType
            )?.codeType;
            const length = codeType?.toUpperCase() === "MODIFIER" ? 1 : 2;
            if (loadOptions.searchValue && loadOptions.searchValue.length > length) {
              dispatch({
                type: SHOW_LOADER,
                data: { isDisableFocusState: true },
              });
              callOperation(GET_EA_TARGET_VALUE_SOURCES, {
                CodeType: codeType,
                CodeSearchStr: loadOptions.searchValue,
                fromServiceDate: new Date(
                  completeCaseDetail.statementFromDate ??
                    auditPropertiesData.serviceFromDate
                ),
                toServiceDate: new Date(
                  completeCaseDetail.statementToDate ??
                    auditPropertiesData.serviceToDate
                ),
                AuditGroupId: caseData.auditGroupId ?? 0,
              }).then((result) => {
                dispatch({
                  type: HIDE_LOADER,
                  data: { isDisableFocusState: false },
                });
                resolve({
                  data: result,
                  totalCount: result?.length,
                });
              });
            } else {
              resolve({
                data: [],
                totalCount: 0,
              });
            }
          });
        },
      }),
    }),
    [
      caseData,
      completeCaseDetail,
      auditPropertiesData,
      targetType,
      targetTypeLookup,
      dispatch,
    ]
  );
}
interface ITargetValueEditorCell {
  e: any; // DataGrid cell editing event (DevExtreme type)
  caseData: any;
  completeCaseDetail: any;
  auditPropertiesData: any;
  targetTypeLookup: any;
  dispatch: any;
}
const TargetValueEditorCell: React.FC<ITargetValueEditorCell> = ({
  e,
  caseData,
  completeCaseDetail,
  auditPropertiesData,
  targetTypeLookup,
  dispatch,
}) => {
  const rowTargetType = e.data?.roundTargetType;

  const rowDatasource = useTargetTypeDatasource({
    targetType: rowTargetType,
    caseData,
    completeCaseDetail,
    auditPropertiesData,
    targetTypeLookup,
    dispatch,
  });

 return rowTargetType && rowTargetType?.toLowerCase() !== "other" ? (
    <MdaeAutoComplete
      id={`txtAutocomplete-${e.data?.eaRoundCaseLineLevelTrackingIdString}`}
      displayExpr="description"
      valueExpr="code"
      disabled={!rowTargetType}
      dataSource={rowDatasource}
      defaultValue={e.value}
      onValueChanged={(ex) => e.setValue(ex.value)}
    />
  ) : (
    <MdaeTextBox
      id={`txtCaseTargetValue-${e.data?.eaRoundCaseLineLevelTrackingIdString}`}
      mdaeTextBoxTitle=""
      maxLength={200}
      value={e.value}
      onValueChanged={(ex) => e.setValue(ex.value)}
    />
  );
};

interface IRoundLineLevelTrackingComponent {
  currentEaRoundCaseId: number;
}
const RoundLineLevelTrackingComponent: React.FC<IRoundLineLevelTrackingComponent> = (
  props
) => {
  const dispatch = useDispatch();
  const chargesListDataGridRef = useRef(null);
  const [currentRoundData, setCurrentRoundData] = useState([]);
  const [roundCharges, setRoundCharges] = useState([]);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);

  const getChargesListDataGridInstance = (): dxDataGrid =>
    chargesListDataGridRef?.current?.instance;

  const roundTargetTypes = useSelector(
    (state) => state["caseDataReducer"].roundTargetTypes ?? []
  );

  const roundLineLevelOutcomeList = useSelector(
    (state: any) => state["outcomesReducer"].roundLineLevelOutcomeList ?? []
  );

  const targetChargesGridSelection = useSelector(
    (state) =>
      state["caseDataReducer"].targetChargesGridSelection?.[props.currentEaRoundCaseId]?.mode ||
      "single"
  );

  const denialReasonData = useSelector(
    (state: any) => state["caseDataReducer"].denialReasonData??[]
  );
  const targetRationaleList = useSelector(
    (state) => state["auditPropertiesReducer"].targetRationaleList ?? []
  );
  const isShowChkbxViewCmpnt = useSelector(
    (state) => state["caseListReducer"].isShowChkbxViewCmpnt
  );
  const caseData = useSelector((state) => state["caseDataReducer"].caseData);
  const auditPropertiesData = useSelector(
    (state: any) => state.auditPropertiesReducer.auditPropertiesData
  );
  const completeCaseDetail = useSelector(
    (state) => state["caseDetailReducer"].completeCaseDetail
  );
  const targetTypeLookup = useSelector(
    (state) => state["caseDataReducer"].targetTypes
  );
 const caseDetailData = useSelector(
    (state) => state["caseDetailReducer"].caseDetailData
  );

  const minEaRoundCaseId =
    caseData?.roundData && caseData.roundData.length > 0
      ? Math.min(...caseData.roundData.map((x) => x.eaRoundCaseId))
      : undefined;
  const isUploadTargetDataPopupVisible = useSelector(
    (state) => state["caseDataReducer"].isUploadTargetDataPopupVisible
  );

 const round = first(currentRoundData);

  const isVisibleCustomButtons =
    minEaRoundCaseId > 0 && props.currentEaRoundCaseId === minEaRoundCaseId
      ? true
      : false;

  const isDisabled = caseData?.roundData?.length === 1 ? false : true;

  useEffect(() => {
    dispatch(actions.asyncOperationStart(GET_OUTCOMES_LIST, {}));
    if (targetRationaleList?.length == 0 || !targetRationaleList) {
      dispatch(actions.asyncOperationStart(GET_TARGET_RATIONALE_LOOKUP_DATA));
    }
  }, []);
  useEffect(() => {
    if (caseData?.roundData && props.currentEaRoundCaseId !== undefined) {
      setCurrentRoundData(
        caseData.roundData.filter(
          (x) => x.eaRoundCaseId === props.currentEaRoundCaseId
        )
      );
    } else {
      setCurrentRoundData([]);
    }
  }, [caseData, props.currentEaRoundCaseId]);

  useEffect(() => {
    if (currentRoundData && currentRoundData.length > 0) {
      setRoundCharges(first(currentRoundData)?.roundCharges || []);
    } else {
      setRoundCharges([]);
    }
  }, [currentRoundData]);
  useEffect(() => {
    if (chargesListDataGridRef && chargesListDataGridRef?.current?.instance) {
      setLineLevelChargesDataGridInstance(chargesListDataGridRef?.current?.instance)
    }
  }, []);

  const toggleTargetChargesGridCheckboxes = () => {
    getChargesListDataGridInstance().beginUpdate();
    if (targetChargesGridSelection === "multiple") {
      dispatch({
        type: SET_TARGET_CHARGES_GRID_CHECKBOXES,
        data: {
          eaRoundCaseId: props.currentEaRoundCaseId,
          targetChargesGridSelection: {
            ...defaultTargetChargesGridSelection,
            mode: "single",
          },
        },
      });
      getChargesListDataGridInstance().clearSelection();
    } else {
      dispatch({
        type: SET_TARGET_CHARGES_GRID_CHECKBOXES,
        data: {
          eaRoundCaseId: props.currentEaRoundCaseId,
          targetChargesGridSelection: {
            ...defaultTargetChargesGridSelection,
            mode: "multiple",
          },
        },
      });
    }
    getChargesListDataGridInstance().endUpdate();
  };

  const onClickAddBtn = useCallback(() => {
    getChargesListDataGridInstance().addRow();
  }, [getChargesListDataGridInstance]);

  const handleBulkActionsClick = useCallback(() => {
    getChargesListDataGridInstance().clearSelection();
    if (targetChargesGridSelection === "multiple") {
      toggleTargetChargesGridCheckboxes();
    } else {
      toggleTargetChargesGridCheckboxes();
    }
  }, [
    getChargesListDataGridInstance,
    targetChargesGridSelection,
    toggleTargetChargesGridCheckboxes,
  ]);

  const onBulkUpdateContentReady = useCallback((e) => {
    $(e.component.element())
      .find(".dx-button-content")
      .addClass(
        "bulk-action-button-content application-section-primary-background-color"
      );
  }, []);

  const onClickImportBtn = useCallback(() => {
    const caseBillingHistoryParams = {
      eaCaseId: caseDetailData.eaCaseId,
      caseId: caseDetailData.caseId,
      caseBranchNo: caseDetailData.caseBillingHistoryList[0].caseBranchNo,
    };
    dispatch(
      actions.asyncOperationStart(
        GET_CASE_BILLING_HISTORY,
        caseBillingHistoryParams
      )
    );
    toggleImportPopup(true, dispatch);
    dispatch({
      type: SET_CURRENT_IMPORT_ROUND_DATA,
      data: {
        currentImportRoundData: {
          eaRoundCaseId: props.currentEaRoundCaseId,
          roundLevelGridInstance: getChargesListDataGridInstance(),
        },
      },
    });
  }, [toggleImportPopup, dispatch, props.currentEaRoundCaseId, caseDetailData]);

  const onClickEditRecords = useCallback(() => {
    const instance = getChargesListDataGridInstance();
    const currentKeys = instance.getSelectedRowKeys(); 
    toggleBulkEditTargetChargesPopup(true, dispatch);
    
    dispatch({
      type: SET_BULK_UPDATE_DATA,
      data: {
        bulkUpdateData: { 
            ...defaultBulkUpdateData,
            gridInstance: instance, 
            selectedRowKeys: currentKeys 
        },
      },
    });
}, [dispatch, getChargesListDataGridInstance]);

  const deleteRecords = useCallback(() => {
    setRoundCharges((prev) => {
      const updatedCharges = prev.filter(
        (item) =>
          !selectedRowKeys.includes(item.eaRoundCaseLineLevelTrackingIdString)
      );
      let denialData = updatedCharges.filter(
        (item) => item.outcomeType === OutcomeTypes.DeniedWillAppeal
      );
      let obj =
        denialData.length > 0
          ? { roundOutcomeId: null, roundOutcomeType: "" }
          : {};
      if (caseData?.roundData && props.currentEaRoundCaseId !== undefined) {
        const roundIndex = caseData.roundData.findIndex(
          (round) => round.eaRoundCaseId === props.currentEaRoundCaseId
        );
        if (roundIndex !== -1) {
          dispatch({
            type: UPDATE_CHARGES_ROUND_DATA,
            data: {
              eaRoundCaseId: props.currentEaRoundCaseId,
              additionalRoundData: obj,
              roundCharges: updatedCharges,
            },
          });
        }
      }
      return updatedCharges;
    });
    setSelectedRowKeys([]);
  }, [caseData, props.currentEaRoundCaseId, dispatch, getChargesListDataGridInstance, selectedRowKeys]);


  const setRoundOutcomeCellValue = useCallback(
    (newData, value, currentRowData) => {
      newData[roundTrackingGridFields.roundOutcomeId] = value;
      const selectedOutcome = (Array.isArray(roundLineLevelOutcomeList)
        ? roundLineLevelOutcomeList
        : []
      ).find((o) => o.eaOutcomeId === value);
      if (selectedOutcome && selectedOutcome.outcomeType) {
        newData[roundTrackingGridFields.outcomeType] =
          selectedOutcome.outcomeType;
      const totalRetainedAmnt = currentRowData.totalRetainedAmnt ?? 0;
      const totalRefundAmnt = currentRowData.totalRefundAmnt ?? 0;
      const reviewRemainingAmnt = currentRowData.reviewRemainingAmnt ?? 0;
        if (selectedOutcome.outcomeType === OutcomeTypes.Approved) {
          newData[roundTrackingGridFields.totalRetainedAmnt] =
            totalRetainedAmnt + reviewRemainingAmnt;
          newData[roundTrackingGridFields.reviewRemainingAmnt] = 0;
        } else if (selectedOutcome.outcomeType === OutcomeTypes.DeniedFinal) {
          newData[roundTrackingGridFields.totalRefundAmnt] =
            totalRefundAmnt + reviewRemainingAmnt;
          newData[roundTrackingGridFields.reviewRemainingAmnt] = 0;
        }
      }
    },
    [roundLineLevelOutcomeList]
  );

  const setRemainingAmountFromAtRiskValue = useCallback(
    (newData, value, currentRowData) => {
      newData[roundTrackingGridFields.atRiskAmnt] = value;
      newData[roundTrackingGridFields.reviewRemainingAmnt] =
        value -
        (currentRowData.totalRetainedAmnt || 0) -
        (currentRowData.totalRefundAmnt || 0) -
        (currentRowData.totalRevenueLoss || 0);

      // Update matching charges in every round
      if (caseData?.roundData && Array.isArray(caseData.roundData)) {
        caseData.roundData.forEach((round) => {
          if (!Array.isArray(round.roundCharges)) return;
          const updatedCharges = round.roundCharges.map((charge) => {
            const isMatch =
              charge.roundTargetType === currentRowData.roundTargetType &&
              charge.roundTargetValue === currentRowData.roundTargetValue &&
              charge.billingCaseDetailId ===
                currentRowData.billingCaseDetailId &&
              charge.claimRemitType === currentRowData.claimRemitType &&
              charge.targetId === currentRowData.targetId &&
              charge.eaRoundCaseLineLevelTrackingIdString !==
                currentRowData.eaRoundCaseLineLevelTrackingIdString;
            if (isMatch) {
              return {
                ...charge,
                atRiskAmnt: value,
                reviewRemainingAmnt:
                  value -
                  (charge.totalRetainedAmnt || 0) -
                  (charge.totalRefundAmnt || 0) -
                  (charge.totalRevenueLoss || 0),
              };
            }
            return charge;
          });
          // Only dispatch if any charge was updated in this round
          const hasUpdate = round.roundCharges.some(
            (charge, idx) => updatedCharges[idx] !== charge
          );
          if (hasUpdate) {
            dispatch({
              type: UPDATE_CHARGES_ROUND_DATA,
              data: {
                eaRoundCaseId: round.eaRoundCaseId,
                roundCharges: updatedCharges,
              },
            });
          }
        });
      }
    },
    [caseData, dispatch]
  );
  const setRemainingAmountFromAtRetainedValue = useCallback(
    (newData, value, currentRowData) => {
      newData[roundTrackingGridFields.totalRetainedAmnt] = value;
      newData[roundTrackingGridFields.reviewRemainingAmnt] =
        (currentRowData.atRiskAmnt|| 0) -
        value -
        (currentRowData.totalRefundAmnt || 0) -
        (currentRowData.totalRevenueLoss || 0);

      // Update matching charges in every round
      if (caseData?.roundData && Array.isArray(caseData.roundData)) {
        caseData.roundData.forEach((round) => {
          if (!Array.isArray(round.roundCharges)) return;
          const updatedCharges = round.roundCharges.map((charge) => {
            const isMatch =
              charge.roundTargetType === currentRowData.roundTargetType &&
              charge.roundTargetValue === currentRowData.roundTargetValue &&
              charge.billingCaseDetailId ===
                currentRowData.billingCaseDetailId &&
              charge.claimRemitType === currentRowData.claimRemitType &&
              charge.targetId === currentRowData.targetId &&
              charge.eaRoundCaseLineLevelTrackingIdString !==
                currentRowData.eaRoundCaseLineLevelTrackingIdString;
            if (isMatch) {
              return {
                ...charge,
                totalRetainedAmnt: value,
                reviewRemainingAmnt:
                  charge.atRiskAmnt - value - (charge.totalRefundAmnt || 0) - (charge.totalRevenueLoss || 0),
              };
            }
            return charge;
          });
          // Only dispatch if any charge was updated in this round
          const hasUpdate = round.roundCharges.some(
            (charge, idx) => updatedCharges[idx] !== charge
          );
          if (hasUpdate) {
            dispatch({
              type: UPDATE_CHARGES_ROUND_DATA,
              data: {
                eaRoundCaseId: round.eaRoundCaseId,
                roundCharges: updatedCharges,
              },
            });
          }
        });
      }
    },
    [caseData, dispatch]
  );

  const setRemainingAmountFromAtRefundValue = useCallback(
    (newData, value, currentRowData) => {
      newData[roundTrackingGridFields.totalRefundAmnt] = value;
      newData[roundTrackingGridFields.reviewRemainingAmnt] =
        (currentRowData.atRiskAmnt || 0) -
        (currentRowData.totalRetainedAmnt || 0) -
        value -
        (currentRowData.totalRevenueLoss || 0);

      // Update matching charges in every round
      if (caseData?.roundData && Array.isArray(caseData.roundData)) {
        caseData.roundData.forEach((round) => {
          if (!Array.isArray(round.roundCharges)) return;
          const updatedCharges = round.roundCharges.map((charge) => {
            const isMatch =
              charge.roundTargetType === currentRowData.roundTargetType &&
              charge.roundTargetValue === currentRowData.roundTargetValue &&
              charge.billingCaseDetailId ===
                currentRowData.billingCaseDetailId &&
              charge.claimRemitType === currentRowData.claimRemitType &&
              charge.targetId === currentRowData.targetId &&
              charge.eaRoundCaseLineLevelTrackingIdString !==
                currentRowData.eaRoundCaseLineLevelTrackingIdString;
            if (isMatch) {
              return {
                ...charge,
                totalRefundAmnt: value,
                reviewRemainingAmnt:
                  charge.atRiskAmnt - (charge.totalRetainedAmnt || 0) - value - (charge.totalRevenueLoss || 0),
              };
            }
            return charge;
          });
          // Only dispatch if any charge was updated in this round
          const hasUpdate = round.roundCharges.some(
            (charge, idx) => updatedCharges[idx] !== charge
          );
          if (hasUpdate) {
            dispatch({
              type: UPDATE_CHARGES_ROUND_DATA,
              data: {
                eaRoundCaseId: round.eaRoundCaseId,
                roundCharges: updatedCharges,
              },
            });
          }
        });
      }
    },
    [caseData, dispatch]
  );

  const setRemainingAmountFromRevenueLossValue = useCallback(
    (newData, value, currentRowData) => {
      newData[roundTrackingGridFields.totalRevenueLoss] = value;
      newData[roundTrackingGridFields.reviewRemainingAmnt] =
        (currentRowData.atRiskAmnt || 0) -
        (currentRowData.totalRetainedAmnt || 0) -
        (currentRowData.totalRefundAmnt || 0) -
        value;

      // Update matching charges in every round
      if (caseData?.roundData && Array.isArray(caseData.roundData)) {
        caseData.roundData.forEach((round) => {
          if (!Array.isArray(round.roundCharges)) return;
          const updatedCharges = round.roundCharges.map((charge) => {
            const isMatch =
              charge.roundTargetType === currentRowData.roundTargetType &&
              charge.roundTargetValue === currentRowData.roundTargetValue &&
              charge.billingCaseDetailId ===
                currentRowData.billingCaseDetailId &&
              charge.claimRemitType === currentRowData.claimRemitType &&
              charge.targetId === currentRowData.targetId &&
              charge.eaRoundCaseLineLevelTrackingIdString !==
                currentRowData.eaRoundCaseLineLevelTrackingIdString;
            if (isMatch) {
              return {
                ...charge,
                totalRevenueLoss: value,
                reviewRemainingAmnt:
                  charge.atRiskAmnt - (charge.totalRetainedAmnt || 0) - (charge.totalRefundAmnt || 0) - value,
              };
            }
            return charge;
          });
          const hasUpdate = round.roundCharges.some(
            (charge, idx) => updatedCharges[idx] !== charge
          );
          if (hasUpdate) {
            dispatch({
              type: UPDATE_CHARGES_ROUND_DATA,
              data: {
                eaRoundCaseId: round.eaRoundCaseId,
                roundCharges: updatedCharges,
              },
            });
          }
        });
      }
    },
    [caseData, dispatch]
  );

  const chargesAssociatedWithRoundDataGridOptions = useMemo(
    () =>
      getRoundLineLevelTrackingComponentOptions(
        roundTargetTypes,
        roundCharges,
        roundLineLevelOutcomeList,
        denialReasonData,
        setRoundOutcomeCellValue,
        setRemainingAmountFromAtRiskValue,
        setRemainingAmountFromAtRetainedValue,
        setRemainingAmountFromAtRefundValue,
        setRemainingAmountFromRevenueLossValue,
        isShowChkbxViewCmpnt,
        props.currentEaRoundCaseId,
        isDisabled,
        targetRationaleList
      ),
    [
      roundTargetTypes,
      roundCharges,
      roundLineLevelOutcomeList,
      denialReasonData,
      setRoundOutcomeCellValue,
      setRemainingAmountFromAtRiskValue,
      setRemainingAmountFromAtRetainedValue,
      setRemainingAmountFromAtRefundValue,
      setRemainingAmountFromRevenueLossValue,
      isShowChkbxViewCmpnt,
      props.currentEaRoundCaseId,
      isDisabled,
      targetRationaleList,
    ]
  );

  const {
    mdaeColumns: columnConfigurations,
    ...restConfigurations
  } = chargesAssociatedWithRoundDataGridOptions;

  const chargesGridCriteraColumns = useMemo(
    () =>
      columnConfigurations.map(
        (columnsProps: IMdaeDataGridColumnProps, idx: number) => {
          if (columnsProps.dataField === "roundTargetValue" || columnsProps.dataField === "supportedValue") {
            return (
              <Column
                key={idx}
                {...columnsProps}
                editCellRender={(e) => {
                  return (
                    <TargetValueEditorCell
                      e={e}
                      caseData={caseData}
                      completeCaseDetail={completeCaseDetail}
                      auditPropertiesData={auditPropertiesData}
                      targetTypeLookup={targetTypeLookup}
                      dispatch={dispatch}
                    />
                  );
                }}
              />
            );
          }
          return <Column key={idx} {...columnsProps} />;
        }
      ),
    [
      columnConfigurations,
      caseData,
      completeCaseDetail,
      auditPropertiesData,
      targetTypeLookup,
      dispatch,
    ]
  );

  const updateDatasource = useCallback(
    (e) => {
      setRoundCharges((prev) => {
        const updatedCharges = prev;
        let denialData = updatedCharges.filter(
          (item) => item.outcomeType === OutcomeTypes.DeniedWillAppeal
        );
        let obj =
          denialData.length > 0
            ? { roundOutcomeId: null, roundOutcomeType: "" }
            : {};
        if (caseData?.roundData && props.currentEaRoundCaseId !== undefined) {
          const roundIndex = caseData.roundData.findIndex(
            (round) => round.eaRoundCaseId === props.currentEaRoundCaseId
          );
          if (roundIndex !== -1) {
            dispatch({
              type: UPDATE_CHARGES_ROUND_DATA,
              data: {
                eaRoundCaseId: props.currentEaRoundCaseId,
                additionalRoundData: obj,
                roundCharges: updatedCharges,
              },
            });
          }
        }
        return updatedCharges;
      });
    },
    [caseData, props.currentEaRoundCaseId, dispatch]
  );

  const onSelectionChanged = useCallback((e)=>{
    setSelectedRowKeys(e.selectedRowKeys);
  },[]);

  const onReOrder = useCallback(
    (e) => {
      let newData = [...roundCharges];
      const movedItem = newData.splice(e.fromIndex, 1)[0];
      newData.splice(e.toIndex, 0, movedItem);
      newData = newData.map((row, idx) => ({ ...row, sortOrder: idx + 1 }));
      const roundIndex = caseData.roundData.findIndex(
        (round) => round.eaRoundCaseId === props.currentEaRoundCaseId
      );
      if (roundIndex !== -1) {
        dispatch({
          type: UPDATE_CHARGES_ROUND_DATA,
          data: {
            eaRoundCaseId: props.currentEaRoundCaseId,
            roundCharges: newData,
          },
        });
      }
    },
    [caseData, props.currentEaRoundCaseId, dispatch, roundCharges]
  );

  const onRowDragging = useMemo(() => {
    return {
      allowReordering: true,
      showDragIcons: false,
      onReorder: onReOrder,
    };
  }, [onReOrder]);

  const openDocumentUploadPopup = useCallback(() => {
    toggleUploadTargetDataPopup(dispatch, true);
  }, [dispatch]);
  return (
    <div id="round-line-level-tracking">
      <DataGrid
        ref={chargesListDataGridRef}
        {...restConfigurations}
        onRowInserted={updateDatasource}
        onRowUpdated={updateDatasource}
        rowDragging={onRowDragging}
        onSelectionChanged={onSelectionChanged}
      >
        <Editing
          mode="cell"
          allowUpdating={true}
          allowAdding={true}
          allowDeleting={false}
          confirmDelete={false}
        />

        <Selection
        mode={targetChargesGridSelection}
          showCheckBoxesMode="always"
          selectAllMode="allPages"
          allowSelectAll={true}
        />
        <Toolbar>
          <Item>
            <MdaeAddButton
              id={""}
              style={{ marginRight: 10 }}
              visible={isVisibleCustomButtons}
              disabled={isDisabled}
              title={"Add New Row"}
              onClick={onClickAddBtn}
            ></MdaeAddButton>
          </Item>
          <Item location="after">
            <MdaeButton
              id={"btnBulkAction"}
              role={"dxButton"}
              stylingMode={"text"}
              className="data-grid-toolbar-button"
              elementAttr={{
                title: "Bulk Action",
              }}
              onContentReady={onBulkUpdateContentReady}
              onClick={handleBulkActionsClick}
            >
              Bulk Actions
            </MdaeButton>
          </Item>
          <Item location="after">
            <Button
              id={"btnBulkEditTargets"}
              icon="dx-icon edit-action-icon"
              className="data-grid-toolbar-button"
              visible={targetChargesGridSelection === "multiple"}
              disabled={selectedRowKeys.length === 0}
              text={""}
              onClick={onClickEditRecords}
              elementAttr={{
                title: "Edit",
              }}
            ></Button>
          </Item>
          <Item>
            <Button
              id={"btnBulkDeleteTargets"}
              icon="dx-icon delete-action-icon"
              className="data-grid-toolbar-button"
              visible={targetChargesGridSelection === "multiple"}
              disabled={selectedRowKeys.length === 0}
              text={""}
              onClick={deleteRecords}
              elementAttr={{
                title: "Delete",
              }}
            ></Button>
          </Item>
          <Item visible={isVisibleCustomButtons && caseDetailData?.caseBillingHistoryList && caseDetailData?.caseBillingHistoryList.length>0} location="after">
            <MdaeButton
              id="btnPullTotalChargeAmount"
              role="dxButton"
              style={isDisabled ? { pointerEvents: "none", opacity: 0.5 } : {}}
              stylingMode="text"
              visible={isVisibleCustomButtons && caseDetailData?.caseBillingHistoryList && caseDetailData?.caseBillingHistoryList.length>0}
              disabled={isDisabled}
              className="no-right-margin pull-total-charge-amount"
              onClick={onClickImportBtn}
            >
              <span className="case-data-field1-dollar-icon">
                <i className="hand-hover dollar-green-icon"></i>
              </span>
            </MdaeButton>
          </Item>
          <Item location="after">
            <Button
              id={"btnUploadDocument"}
              visible={isVisibleCustomButtons}
              disabled={isDisabled}
              icon={"dx-icon upload-icon"}
              className="data-grid-toolbar-button"
              onClick={openDocumentUploadPopup}
            ></Button>
          </Item>
        </Toolbar>
        {chargesGridCriteraColumns}
      </DataGrid>
      <BulkEditTargetCharges
        isDisabled={isDisabled}
      />
      <RoundLevelImportPopup />
      {isUploadTargetDataPopupVisible && round && (
        <UploadTargetDataPopup
          eaRoundId={round.eaRoundId}
          setRoundCharges={setRoundCharges}
          eaCaseId={round.eaCaseId}
          currentEaRoundCaseId={props.currentEaRoundCaseId}
        />
      )}
    </div>
  );
};

const getRoundLineLevelTrackingComponentOptions = (
  roundTargetTypes,
  roundCharges,
  roundLineLevelOutcomeList,
  denialReasonData,
  setRoundOutcomeCellValue,
  setRemainingAmountFromAtRiskValue,
  setRemainingAmountFromAtRetainedValue,
  setRemainingAmountFromAtRefundValue,
  setRemainingAmountFromRevenueLossValue,
  isShowChkbxViewCmpnt,
  currentEaRoundCaseId,
  isDisabled,
  targetRationaleList
) => {

  const chargesAssociatedWithCaseRoundDataConfig: IMdaeDataGridProps = {
    id: "gridChargesAssociatedWithRound" + currentEaRoundCaseId,
    keyExpr: "eaRoundCaseLineLevelTrackingIdString",
    allowColumnResizing: true,
    allowColumnReordering: true,
    filterRow: { visible: true },

    showBorders: true,
    showColumnLines: true,
    showRowLines: true,
    headerFilter: {
      visible: true,
    },
    dataSource: roundCharges,
    mdaeColumns: [
      {
        dataField: "revenueCode",
        caption: "Revenue Code",
        dataType: "string",
        visible: isShowChkbxViewCmpnt,
      },
      {
        dataField: "roundTargetType",
        caption: "Target Type",
        dataType: "string",
        allowEditing: !isDisabled,
        lookup: {
          dataType: "string",
          serializationFormat: "string",
          dataSource: roundTargetTypes,
          valueExpr: "value",
          displayExpr: "displayName",
        },
      },
      {
        dataField: "roundTargetValue",
        allowEditing: !isDisabled,
        caption: "Target Value",
        dataType: "string",
      },

      {
        dataField: "supportedValue",
        caption: "Supported Value",
        dataType: "string",
      },

      {
        dataField: "finalValue",
        caption: "Final Value",
        dataType: "string",
      },

      {
        dataField: "targetRationale",
        caption: "Target Rationale",
        dataType:"string",
        lookup: {
          dataType: "string",
          serializationFormat: "string",
          dataSource: targetRationaleList,
          valueExpr: "value",
          displayExpr: "name",
        },
      },

      {
        dataField: "denialReason",
        caption: "Denial Reason",
        dataType:"string",
        lookup: {
          dataType: "string",
          serializationFormat: "string",
          dataSource: denialReasonData,
          valueExpr: "code",
          displayExpr: "denialReasonName"
        },
      },

      {
        dataField: "atRiskAmnt",
        caption: "At Risk",
        dataType: "number",
        alignment: "right",
        format: {
          type: "currency",
          precision: 2,
        },
        setCellValue: setRemainingAmountFromAtRiskValue,
      },

      {
        dataField: "totalRetainedAmnt",
        caption: "Retained",
        dataType: "number",
        alignment: "right",
        format: {
          type: "currency",
          precision: 2,
        },
        setCellValue: setRemainingAmountFromAtRetainedValue,
      },

      {
        dataField: "totalRefundAmnt",
        caption: "Refund",
        dataType: "number",
        alignment: "right",
        format: {
          type: "currency",
          precision: 2,
        },
        setCellValue: setRemainingAmountFromAtRefundValue,
      },

      {
        dataField: "totalRevenueLoss",
        caption: "Revenue Loss",
        dataType: "number",
        alignment: "right",
        format: {
          type: "currency",
          precision: 2,
        },
        setCellValue: setRemainingAmountFromRevenueLossValue,
      },

      {
        dataField: "reviewRemainingAmnt",
        caption: "Remaining $ In Review",
        dataType: "number",
        alignment: "right",
        format: {
          type: "currency",
          precision: 2,
        },
        allowEditing: false,
      },

      {
        dataField: "roundOutcomeId",
        caption: "Round Outcome",
        dataType:"string",
        lookup: {
          dataType: "string",
          serializationFormat: "string",
          dataSource: roundLineLevelOutcomeList,
          valueExpr: "eaOutcomeId",
          displayExpr: "eaOutcomeName"
        },
        setCellValue: setRoundOutcomeCellValue,
      },
    ],
  };
  return chargesAssociatedWithCaseRoundDataConfig;
};

interface IBulkEditTargetChargesProps {
  isDisabled?: boolean;
}
const BulkEditTargetCharges: React.FC<IBulkEditTargetChargesProps> = ({
  isDisabled,
}) => {
  const dispatch = useDispatch();

  const denialReasonData = useSelector(
    (state: any) => state["caseDataReducer"].denialReasonData
  );
  const roundTargetTypes = useSelector(
    (state) => state["caseDataReducer"].roundTargetTypes
  );
  const gridInstance = useSelector(
    (state: any) => state["caseDataReducer"].bulkUpdateData.gridInstance
  );
  const selectedRowKeys = useSelector(
    (state) => state["caseDataReducer"].bulkUpdateData.selectedRowKeys
  );
  const roundLineLevelOutcomeList = useSelector(
    (state: any) => state["outcomesReducer"].roundLineLevelOutcomeList
  );
  const bulkUpdateData = useSelector(
    (state: any) => state["caseDataReducer"].bulkUpdateData
  );

  const auditPropertiesData = useSelector(
    (state: any) => state.auditPropertiesReducer.auditPropertiesData
  );
  const completeCaseDetail = useSelector(
    (state) => state["caseDetailReducer"].completeCaseDetail
  );
  const caseData = useSelector((state) => state["caseDataReducer"].caseData);

  const targetTypeLookup = useSelector(
    (state) => state["caseDataReducer"].targetTypes
  );
  const targetRationaleList = useSelector(
    (state) => state["auditPropertiesReducer"].targetRationaleList
  );

  const onBulkEditFieldChange = useCallback((e) => {
    dispatch({
      type: SET_BULK_UPDATE_DATA,
      data:  { bulkUpdateData: { [e.component.option('name')]: e.value }}
    });
  }, [dispatch]);

  const ddlTargetTypeDatasource = useTargetTypeDatasource({
    targetType: bulkUpdateData.targetType,
    caseData,
    completeCaseDetail,
    auditPropertiesData,
    targetTypeLookup,
    dispatch,
  });
  const bulkEditPopupContentRender = useCallback(() => {
    return (
      <MdaePopupContent>
        <div id={"bulk-edit-popup"}>
          {!isDisabled && (
            <div className={"bulk-edit-popup-flex top-margin"}>
              <div className={"bulk-edit-popup-field"}>
                <MdaeSelectBox
                  id={"ddlTargetType"}
                  mdaeDropDownBoxTitle={"Target Type"}
                  displayExpr={"displayName"}
                  valueExpr={"value"}
                  disabled={isDisabled}
                  name={"targetType"}
                  value={bulkUpdateData.targetType}
                  dataSource={roundTargetTypes || []}
                  onValueChanged={onBulkEditFieldChange}
                ></MdaeSelectBox>
              </div>
              <div className={"bulk-edit-popup-field"}>
                {bulkUpdateData.targetType &&
                bulkUpdateData.targetType.toLowerCase() === "other" ? (
                  <MdaeTextBox
                    id={`txtBulkEditTargetValue`}
                    mdaeTextBoxTitle="Target Value"
                    maxLength={200}
                    name={"targetValue"}
                    value={bulkUpdateData.targetValue}
                    onValueChanged={onBulkEditFieldChange}
                  />
                ) : (
                  <MdaeAutoComplete
                    id={"ddlTargetValue"}
                    mdaeAutocompleteTitle={"Target Value"}
                    displayExpr={"description"}
                    valueExpr={"code"}
                    minSearchLength={3}
                    name={"targetValue"}
                    value={bulkUpdateData.targetValue}
                    dataSource={ddlTargetTypeDatasource}
                    disabled={!bulkUpdateData.targetType || isDisabled}
                    onValueChanged={onBulkEditFieldChange}
                  ></MdaeAutoComplete>
                )}
              </div>
            </div>
          )}
          <div className={"bulk-edit-popup-flex top-margin"}>
            <div className={"bulk-edit-popup-field"}>
              <MdaeSelectBox
                id={"ddlDenialReason"}
                mdaeDropDownBoxTitle={"Denial Reason"}
                displayExpr={"denialReasonName"}
                valueExpr={"code"}
                name={"denialReason"}
                value={bulkUpdateData.denialReason}
                dataSource={denialReasonData || []}
                onValueChanged={onBulkEditFieldChange}
              ></MdaeSelectBox>
            </div>
            <div className={"bulk-edit-popup-field"}>
              <MdaeSelectBox
                id={"ddlTargetRationale"}
                mdaeDropDownBoxTitle={"Target Rationale"}
                displayExpr={"name"}
                valueExpr={"value"}
                name={"targetRationale"}
                value={bulkUpdateData.targetRationale}
                dataSource={targetRationaleList || []}
                onValueChanged={onBulkEditFieldChange}
              ></MdaeSelectBox>
            </div>
          </div>
            <div className={"bulk-edit-popup-flex top-margin"}>
              <div className={"bulk-edit-popup-field"}>
                <MdaeSelectBox
                  id={"ddlRoundOutcome"}
                  mdaeDropDownBoxTitle={"Round Outcome"}
                  displayExpr={"eaOutcomeName"}
                  valueExpr={"eaOutcomeId"}
                  name={"roundOutcome"}
                  value={bulkUpdateData.roundOutcome}
                  dataSource={roundLineLevelOutcomeList || []}
                  onValueChanged={onBulkEditFieldChange}
                ></MdaeSelectBox>
              </div>
            </div>
        </div>
      </MdaePopupContent>
    );
  }, [
    bulkUpdateData,
    roundTargetTypes,
    denialReasonData,
    roundLineLevelOutcomeList,
    dispatch,
  ]);

  const onClickBulkUpdate = useCallback(() => {
    if (gridInstance ) {
      var rows = gridInstance?.getSelectedRowKeys();
      if(rows && rows.length>0){
        gridInstance.beginUpdate();
        rows.forEach((key) => {
          const rowIndex = gridInstance.getRowIndexByKey(key);
          if (rowIndex !== -1) {
            if (
              bulkUpdateData.targetType !== undefined &&
              bulkUpdateData.targetType !== null &&
              bulkUpdateData.targetType !== ""
            )
              gridInstance.cellValue(
                rowIndex,
                roundTrackingGridFields.roundTargetType,
                bulkUpdateData.targetType
              );
            if (
              bulkUpdateData.targetValue !== undefined &&
              bulkUpdateData.targetValue !== null &&
              bulkUpdateData.targetValue !== ""
            )
              gridInstance.cellValue(
                rowIndex,
                roundTrackingGridFields.roundTargetValue,
                bulkUpdateData.targetValue
              );
            if (
              bulkUpdateData.denialReason !== undefined &&
              bulkUpdateData.denialReason !== null &&
              bulkUpdateData.denialReason !== ""
            )
              gridInstance.cellValue(
                rowIndex,
                roundTrackingGridFields.denialReason,
                bulkUpdateData.denialReason
              );
            if (
              bulkUpdateData.roundOutcome !== undefined &&
              bulkUpdateData.roundOutcome !== null &&
              bulkUpdateData.roundOutcome > 0
            ) {
              gridInstance.cellValue(
                rowIndex,
                roundTrackingGridFields.roundOutcomeId,
                bulkUpdateData.roundOutcome
              );
              // Set outcomeType from selected outcome object
              const selectedOutcome = (Array.isArray(roundLineLevelOutcomeList)
                ? roundLineLevelOutcomeList
                : []
              ).find((o) => o.eaOutcomeId === bulkUpdateData.roundOutcome);
              if (selectedOutcome && selectedOutcome.outcomeType) {
                gridInstance.cellValue(
                  rowIndex,
                  roundTrackingGridFields.outcomeType,
                  selectedOutcome.outcomeType
                );
              }
            }
            if (
              bulkUpdateData.targetRationale !== undefined &&
              bulkUpdateData.targetRationale !== null &&
              bulkUpdateData.targetRationale > 0
            ) {
              gridInstance.cellValue(
                rowIndex,
                roundTrackingGridFields.targetRationale,
                bulkUpdateData.targetRationale
              );
            }
          }
        });
        gridInstance.endUpdate();
        gridInstance.saveEditData && gridInstance.saveEditData();
      }
    }
    toggleBulkEditTargetChargesPopup(false, dispatch);
    dispatch({
      type: SET_BULK_UPDATE_DATA,
      data: {
        bulkUpdateData: {
          ...bulkUpdateData,
          targetValue: "",
        },
      },
    });
  }, [
    gridInstance,
    bulkUpdateData,
    roundLineLevelOutcomeList,
    dispatch,
    selectedRowKeys
  ]);

  const popupTitleRender = useCallback(() => {
    return (
      <MdaePopupTitle
        closePopupHandler={() =>
          toggleBulkEditTargetChargesPopup(false, dispatch)
        }
      >
        Edit Charges
      </MdaePopupTitle>
    );
  }, [dispatch]);

  const bulkUpdateMDAEDataUpdaterConfig = useMemo(
    () => [
      {
        actionType: TOGGLE_BULK_EDIT_TARGET_CHARGES_POPUP,
        reducerName: "caseDataReducer",
        widgetOptionBindings: {
          visible: "isBulkEditTargetChargesPopupVisible",
        },
      },
    ],
    []
  );

  return (
    <MdaePopup
      deferRendering={false}
      width={"700px"}
      height={isDisabled ? "320px" : "370px"}
      mdaeTitleRender={popupTitleRender}
      mdaeDataUpdaterConfig={bulkUpdateMDAEDataUpdaterConfig}
      mdaeContentRender={bulkEditPopupContentRender}
      mdaeFooterRender={() => {
        return (
          <MdaePopupFooter>
            <MdaePopupFooterStartButtons>
              <MdaeButton
                id={"btnCancelBulkEdit"}
                role={"secondary"}
                onClick={() => {
                  toggleBulkEditTargetChargesPopup(false, dispatch);
                }}
              >
                Cancel
              </MdaeButton>
            </MdaePopupFooterStartButtons>
            <MdaePopupFooterEndButtons>
              <MdaeButton
                id={"btnUpdateBulkEdit"}
                role={"primary"}
                onClick={onClickBulkUpdate}
              >
                Update
              </MdaeButton>
            </MdaePopupFooterEndButtons>
          </MdaePopupFooter>
        );
      }}
    ></MdaePopup>
  );
};

const RoundLevelImportPopup: React.FC = () => {
  const dispatch = useDispatch();
  const caseDetailData = useSelector(
    (state) => state["caseDetailReducer"].caseDetailData
  );
  const caseData = useSelector((state) => state["caseDataReducer"].caseData);

   const billingHistoryList = useSelector(
     (state) => state["billHistoryReducer"].billingHistoryList
   );
   const remitBtnOnClick = useCallback(() => {
     dispatch({
       type: SET_FROM_IMPORT_TYPE,
       data: {
         isImportType: importType.REMIT,
       },
     });
     const billData = {
       parent: caseDetailData,
       child: caseDetailData.caseBillingHistoryList[0],
     };
     const params = {
       caseDetailId: billingHistoryList[0]?.atRiskCaseDetailId || 0,
       patientType: caseDetailData.caseBillingHistoryList[0].billTypeFacility,
       claimType: caseData.claimType,
       eaCaseId: caseData.eaCaseId,
       varToUpdate: atRisk,
     };
     toggleImportPopup(false, dispatch);
     toggleBillHistoryPopupVisible(
       dispatch,
       true,
       billData,
       false,
       atRisk,
       true
     );
     if (params.caseDetailId > 0) {
       setTimeout(() => {
         toggleRemitDetailPopupVisible(dispatch, true, params);
       }, 2000);
     }
   }, [
     caseDetailData,
     dispatch,
     caseData,
     billingHistoryList[0]?.atRiskCaseDetailId,
   ]);

  const claimBtnOnClick = useCallback(() => {
    dispatch({
      type: SET_FROM_IMPORT_TYPE,
      data: {
        isImportType: importType.CLAIM,
      },
    });
    const billData = {
      parent: caseDetailData,
      child: caseDetailData.caseBillingHistoryList[0],
    };
    toggleImportPopup(false, dispatch);
    toggleBillHistoryPopupVisible(
      dispatch,
      true,
      billData,
      false,
      "importCharges",
      true
    );
    setTimeout(() => {
      toggleClaimDetailPopupVisible(dispatch, true, caseDetailData);
    }, 2000);
  }, [caseDetailData, dispatch]);

  const importPopupContentRender = useCallback(() => {
    return (
      <MdaePopupContent>
        <div>Where do you want to import from ?</div>
        <ClaimDetail />
      </MdaePopupContent>
    );
  }, []);

  const importPopupTitleRender = useCallback(() => {
    return (
      <MdaePopupTitle
        closePopupHandler={() => toggleImportPopup(false, dispatch)}
      >
        Round Line Import
      </MdaePopupTitle>
    );
  }, [dispatch]);

  const importMdaeDataUpdaterConfig = useMemo(
    () => [
      {
        actionType: TOGGLE_IMPORT_POPUP,
        reducerName: "caseDataReducer",
        widgetOptionBindings: {
          visible: "isImportPopupVisible",
        },
      },
    ],
    []
  );

  return (
    <MdaePopup
      deferRendering={false}
      width={"480"}
      height={"280"}
      mdaeTitleRender={importPopupTitleRender}
      mdaeDataUpdaterConfig={importMdaeDataUpdaterConfig}
      mdaeContentRender={importPopupContentRender}
      mdaeFooterRender={() => {
        return (
          <MdaePopupFooter>
            <MdaePopupFooterStartButtons>
              <MdaeButton
                id={"btnCancelImport"}
                role={"secondary"}
                onClick={() => {
                  toggleImportPopup(false, dispatch);
                }}
              >
                Cancel
              </MdaeButton>
            </MdaePopupFooterStartButtons>
            <MdaePopupFooterEndButtons>
              <MdaeButton
                id={"btnUpdateClaim"}
                role={"primary"}
                onClick={claimBtnOnClick}
              >
                Claim
              </MdaeButton>
              <MdaeButton
                id={"btnUpdateRemit"}
                role={"primary"}
                onClick={remitBtnOnClick}
              >
                Remit
              </MdaeButton>
            </MdaePopupFooterEndButtons>
          </MdaePopupFooter>
        );
      }}
    ></MdaePopup>
  );
};

export default RoundLineLevelTrackingComponent;
